<template>
    <div>
        <div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <app-tabela
                idTabela="tblDotacoesOrcamentarias"
                :itens="contrato.dotacoesOrcamentarias"
                :campos="campos"
                :itensPorPagina="itensPorPagina"
                :bordered="false"
                :small="false"
            >
                <template slot="botoes">
                    <div class="d-flex flex-row-reverse mb-3">
                        <btn-inserir-dotacao
                            :contrato="contrato"
                            :apostilamento="apostilamento()"
                            @obterDotacoesAtualizadas="
                                $emit('obterDotacoesAtualizadas')
                            "
                            v-if="mostrarBtnInserirDotacao"
                        ></btn-inserir-dotacao>
                    </div>
                </template>
                <template slot="acoes" slot-scope="data">
                    <btn-atualizar-dotacao
                        :dotacao="data"
                        :contrato="contrato"
                        :apostilamento="apostilamento()"
                        v-if="mostrarBtnAtualizarDotacao"
                        @obterDotacoesAtualizadas="
                            $emit('obterDotacoesAtualizadas')
                        "
                    ></btn-atualizar-dotacao>
                    <btn-excluir-dotacao
                        :dotacao="data"
                        :contrato="contrato"
                        :apostilamento="apostilamento()"
                        v-if="mostrarBtnExcluirDotacao"
                        @obterDotacoesAtualizadas="
                            $emit('obterDotacoesAtualizadas')
                        "
                        @erros="erros=$event"
                    ></btn-excluir-dotacao>
                </template>
            </app-tabela>
        </div>
    </div>
</template>

<script>
import BtnAtualizarDotacao from './BtnAtualizarDotacao'
import BtnInserirDotacao from './BtnInserirDotacao'
import BtnExcluirDotacao from './BtnExcluirDotacao'
import { situacaoContrato } from '../SituacaoContrato'

export default {
    components: {
        BtnAtualizarDotacao,
        BtnInserirDotacao,
        BtnExcluirDotacao
    },

    props: {
        contrato: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            dotacao: null,
            erros: [],
            campos: [
                {
                    key: 'unidade',
                    label: 'Unidade',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'projeto',
                    label: 'Projeto',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'acao',
                    label: 'Ação',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 10
        }
    },
    methods: {
        situacoesVigenteDistribuido() {
            return (
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE2 ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_DISTRIBUIDO ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_DISTRIBUIDO
            )
        },

        apostilamento() {
            return (
                this.$temAcessoView('CONT-APOST-02') &&
                this.situacoesVigenteDistribuido()
            )
        },

        contratoElaboracao() {
            return (
                this.$temAcessoView('CONT-ELAB-01') &&
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO
            )
        },

        aditivoContratoIniciado() {
            return (
                this.$temAcessoView('CONT-ADITIV-01') &&
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.ADITIVO_ASSINADO_AGUARDANDO_INTEGRACAO
            )
        },

        atualizacaoContrato() {
            return (
                this.$temAcessoView('CONT-ATUALIZAR-00') &&
                this.situacoesVigenteDistribuido() &&
                this.contrato.contratoVigente
            )
        },

        controleHistoricoAditivos() {
            return (
                this.contrato.contratoVigente ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.INICIADO_ADITIVO_CONTRATO ||
                    this.contrato.idSituacaoContrato ==
                        situacaoContrato.ADITIVO_ASSINADO_AGUARDANDO_INTEGRACAO
            )
        },
    },

    created() {},

    computed: {
        mostrarBtnInserirDotacao() {
            let podeInsirirDotacao = true
            //Retirada devido a evolução dos comprometimento de pf e entregas com mais de uma dotação
            // if (this.contrato.idTipoContrato === 1) {
            // 	podeInsirirDotacao = true
            // } else if (this.contrato.idTipoContrato !== 1) {
            // 	if (this.contrato.dotacoesOrcamentarias) {
            // 		if (this.contrato.dotacoesOrcamentarias.length === 0) {
            // 			podeInsirirDotacao = true
            // 		}
            // 	}
            // }
            return (
                ((this.apostilamento() && podeInsirirDotacao) ||
                    this.contratoElaboracao() ||
                    this.aditivoContratoIniciado() ||
                    this.atualizacaoContrato()) &&
                this.controleHistoricoAditivos()
            )
        },

        mostrarBtnExcluirDotacao() {
            let podeExcluir = 
                (this.apostilamento() ||
                    this.contratoElaboracao() ||
                    this.aditivoContratoIniciado() ||
                    this.atualizacaoContrato()) &&
                this.controleHistoricoAditivos()
            
            if (!this.contratoPorMedicao) {
                podeExcluir = podeExcluir && 
                    this.contrato.dotacoesOrcamentarias.length > 1
            }
            
            return podeExcluir
        },

        contratoPorMedicao() {
            return this.contrato.idTipoContrato === 1
        },

        contratoSemDotacao() {
            if (this.contrato.idTipoContrato == 1) {
                return false
            }
            if (this.contrato.dotacoesOrcamentarias == null ||
                this.contrato.dotacoesOrcamentarias.length == 0    
            ) {
                return true
            } 
            return false
        },

        mostrarBtnAtualizarDotacao() {
            return (
                (this.apostilamento() ||
                    this.contratoElaboracao() ||
                    this.aditivoContratoIniciado() ||
                    this.atualizacaoContrato()) &&
                this.controleHistoricoAditivos()
            )
        }
    },

    watch: {}
}
</script>
